export { default } from './part-other-cases';
